<template>
<div class="scale2"
     :style="scaleStyle"
     ref="previewMain">
  <div class="doc-paper preview rirekisho">
    <div class="flex">
      <div class="rirekisho-box1 full">
        <div class="rirekisho-header">
          <div class="title slim">履歴書</div>
          <div class="date"
               @click="goCardTo('create-date')"
               :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span> 現在
          </div>
        </div>
        <div class="rirekisho-profile"
             @click="$eventHub.$emit('go-card-to', 'profile')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastNameFurigana }}&emsp;{{ basicData.firstNameFurigana }}</div>
          </div>
          <div class="name slim flex">
            <div class="label">名前</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
          </div>
          <div class="etc slim flex">
            <div class="birthday" :style="formatData.selFontStyle"> <span class="year">{{ basicData.birthYear }}</span>年 <span class="month">{{ basicData.birthMonth }}</span>月 <span class="day">{{ basicData.birthDay }}</span>日生（満 <span class="age">{{ age }}</span> 歳）</div>
            <div class="gender">
              <span class="male" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isMale}">男</span><span v-if="!isGenderDisplay">・</span>
              <span class="female" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isFemale}">女</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="rirekisho-box2">
      <div class="contact-information contact-main flex">
        <div class="contact-information-address"
             @click="$eventHub.$emit('go-card-to', 'address')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input"
                 :class="{'font-size-sm': ($formLib.charCount(basicData.addressFurigana) > 59) }" :style="formatData.selFontStyle">{{ basicData.addressFurigana }}</div>
          </div>
          <div class="address flex">
            <div class="label">現住所</div>
            <div class="input">
              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
              <pre :style="formatData.selFontStyle">{{ basicData.address1}} {{ basicData.address2 }}</pre>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             @click="$eventHub.$emit('go-card-to', 'contacts')">
          <div class="tel flex">
            <div class="label">電話</div>
            <div class="input" :style="formatData.selFontStyle">{{ tel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.email }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-table rirekisho-table-slim rirekisho-history-1"
         @click="$eventHub.$emit('go-card-to', 'edu-history')">
      <table>
        <thead>
          <tr>
            <th>년</th>
            <td>월</td>
            <td>학력・경력</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in eduJobHistoryTable"
              v-bind:class="item.classObject"
              v-if="index <= 9"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-table rirekisho-table-slim rirekisho-skill"
         @click="$eventHub.$emit('go-card-to', 'license-history')"
         :id="idPrefix + 'preview-page-02'">
      <table :class="{error:this.errorMessages.licenseHistory}">
        <thead>
          <tr>
            <th>년</th>
            <td>월</td>
            <td>면허・자격증</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in licenseHistoryTable"
              v-bind:class="item.classObject"
              v-if="index <= 3"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-pr-slim">
      <div class="rirekisho-pr-reason"
           @click="$eventHub.$emit('go-card-to', 'reason')">
        <div class="label">지원동기, 특기, 어필포인트 등</div>
        <div class="input">
          <pre ref="reason"
               :class="classObject.reason" :style="formatData.selFontStyle">{{ formatData.reason }}</pre>
        </div>
      </div>
      <div class="rirekisho-pr-etc"
           @click="$eventHub.$emit('go-card-to', 'others')">
        <div class="time">
          <div class="label">통근시간</div>
          <div class="input text-right" :style="formatData.selFontStyle">약 <span>{{ formatData.commuteHours }}</span> 시간 <span>{{ formatData.commuteMinutes }}</span> 분</div>
        </div>
        <div class="family">
          <div class="label">부양가족 수(배우자 제외)</div>
          <div class="input text-right" :style="formatData.selFontStyle"><span>{{ formatData.spouseNumber }}</span> 명</div>
        </div>
        <div class="partner">
          <div class="existence">
            <div class="label">배우자</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.hasSpouse}">유</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.hasSpouse}">무</span></div>
          </div>
          <div class="support">
            <div class="label">배우자의 부양의무</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.underDutyToSupport}">유</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.underDutyToSupport}">무</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-hope-slim"
         @click="$eventHub.$emit('go-card-to', 'requests')">
      <div class="label">본인희망란</div>
      <div class="input">
        <pre ref="request"
             :class="classObject.request" :style="formatData.selFontStyle">{{ formatData.request }}</pre>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import RirekishoPreviewMixin from '@/mixins/rirekisho-preview-mixin'
export default {
  name: 'rirekishoNophotoPreview',
  mixins: [RirekishoPreviewMixin],
  data: function () {
    return {
      maxEduJobRows: 10,
      maxLicenseRows: 4,
      textareaMaxHeights: {
        reason: 60,
        request: 72
      },
      optionItems: {
        commuteDescription: false
      }
    }
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('reason')
      this.adjustFontSize('reasonNew')
      this.adjustFontSize('request')
      this.adjustFontSize('addressFurigana')
    }
  }
}
</script>
